// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1t5br","colMaxWidth":"Table_colMaxWidth__3kTBs"};